import "./allCurrencies.scss";
import CurrencyCard from "../CurrencyCard";

import React, { useEffect, useState } from "react";
import moment from "jalali-moment";

import currencyIcon from "../../assets/icons/currency.png";
import Spinner from "../Spinner";

const AllCurrencies = ({ currencies, isLoading }) => {
  const [jalali, setJalali] = useState("");
  const sortedCurrencies = currencies
    .slice()
    .sort((a, b) => a.currencyId - b.currencyId);

  useEffect(() => {
    moment.locale("fa", { useGregorianParser: true });
    setJalali(moment(currencies[0]?.updatedAt).format("YYYY/MM/DD HH:mm"));
  }, [currencies]);

  return (
    <div className="all-currency-container">
      <div className="space-between">
        <div className="title-container">
          <div className="title">
            <img src={currencyIcon} alt="currency" />
            نرخ ارز
          </div>
          <div className="latest-update">آخرین نرخ بروزرسانی : {jalali}</div>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="all-currencies">
          {sortedCurrencies?.map((currency) => {
            return <CurrencyCard key={currency.id} currency={currency} />;
          })}
        </div>
      )}
    </div>
  );
};

export default AllCurrencies;
